export default __webpack_public_path__ + "static/INSTAR_Cloud_Alexa_Skill_20-EN-c58284e07d81bd3d46f4356395e7f8fe.webp";